export const getScript = (source, crossOrigin = null) => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        const head = document.querySelector('head');
        script.async = true;
        if (crossOrigin) {
            script.crossOrigin = crossOrigin;
        }
        script.addEventListener('load', (element, event) => resolve(element));
        script.src = source;
        head.appendChild(script);
    });
};
export const getCss = (source) => {
    return new Promise((resolve) => {
        const link = document.createElement('link');
        const head = document.querySelector('head');
        link.rel = 'stylesheet';
        link.crossOrigin = 'anonymous';
        link.addEventListener('load', (element, event) => resolve(element));
        link.href = source;
        head.appendChild(link);
    });
};
